export default __webpack_public_path__ + "static/media/2013-SP.d692f9b8.jpg";